import styled, { css } from 'styled-components';

import { Layer, StyledFlex } from '@dreryk/react-components';

const WINDOW_HEIGHT_IN_PX = 446;
const WINDOW_WIDTH_IN_PX = 462;

type StyledVideoConsultationWindowProps = {
   $visible: boolean | undefined;
   $dragging: boolean | undefined;
};

export const StyledVideoConsultationWindow = styled.div<StyledVideoConsultationWindowProps>`
   background-color: ${(props) => props.theme.backgroundBody};
   border: 2px solid ${(props) => props.theme.borderLighter};
   border-radius: 20px;
   padding: 0;
   overflow: hidden;
   position: fixed;
   display: flex;
   flex-direction: column;
   transition: opacity 300ms ease-in-out;
   opacity: 0;
   pointer-events: none;
   z-index: ${Layer.Window};
   min-width: ${WINDOW_WIDTH_IN_PX}px;
   min-height: ${WINDOW_HEIGHT_IN_PX}px;

   ${(props) =>
      props.$visible &&
      css`
         opacity: 1;
         pointer-events: auto;
      `}

   ${(props) =>
      props.$dragging &&
      css`
         user-select: none;
      `}
`;

StyledVideoConsultationWindow.displayName = 'StyledVideoConsultationWindow';

export const StyledMenuBar = styled(StyledFlex)`
   background-color: ${(props) => props.theme.backgroundLighter};
   padding: 10px 18px;
   cursor: move;
`;

StyledMenuBar.displayName = 'StyledMenuBar';
